import { notifications } from "@mantine/notifications";
import i18n from "common/i18n";

export const getLangParam = () => i18n.language || "en";

export const showError = (message: string, autoClose = false) => {
  notifications.show({
    autoClose,
    color: "red",
    message,
  });
};

export const showSuccess = (message: string) => {
  notifications.show({
    autoClose: 1700,
    color: "green",
    message,
  });
};

export const showInfo = (message: string, color?: string) => {
  notifications.show({
    autoClose: 2000,
    color: color ?? "gray",
    message,
  });
};

const formatMilliseconds = (milliseconds: number) => {
  const hours = Math.floor(milliseconds / 3600000);
  const minutes = Math.floor((milliseconds % 3600000) / 60000);
  const seconds = Math.floor(((milliseconds % 3600000) % 60000) / 1000);

  const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
  const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const secondsStr = seconds < 10 ? `0${seconds}` : `${seconds}`;

  return `${
    hoursStr !== "00" ? hoursStr + ":" : ""
  }${minutesStr}:${secondsStr}`;
};

export const timeElapsed = (date: Date) =>
  formatMilliseconds(new Date().getTime() - new Date(date).getTime());

export const hasFilters = (filters: unknown): boolean => {
  if (!filters) {
    return false;
  }

  if (typeof filters !== "object") {
    return false;
  }

  const keys = Object.keys(filters);

  if (keys.length === 0) {
    return false;
  }

  const isEveryValuesEmpty = Object.values(filters).every(filter => {
    return !Boolean(filter);
  });

  if (isEveryValuesEmpty) {
    return false;
  }

  return true;
};

export const createFilterTags = (filter: Record<string, boolean>): string => {
  let result = "";
  for (const key in filter) {
    if (!filter[key]) continue;
    if (result) result += ",";
    result += key;
  }
  return result;
};
